import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=3cd402b4&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=js"
export * from "./HelpCenter.vue?vue&type=script&lang=js"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=3cd402b4&prod&scoped=true&lang=css"
import style1 from "./HelpCenter.vue?vue&type=style&index=1&id=3cd402b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd402b4",
  null
  
)

export default component.exports